import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { tap, shareReplay, startWith } from 'rxjs/operators';
import { IndirizzoDTO } from '../../models/indirizzo-dto';
import { Localita } from '../../models/portale/localita';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';

@Component({
	selector: 'lib-indirizzo',
	templateUrl: './indirizzo.component.html',
	styleUrls: ['./indirizzo.component.css']
})
export class IndirizzoComponent implements OnInit {

	form: FormGroup;

	@Input()
	indirizzo: IndirizzoDTO;

	@Input()
	viewOnly: boolean;

	@Input()
	province: Observable<Array<Localita>>;

	@Input()
	descrizioneLocalia: String;

	@Output()
	done: EventEmitter<ComponentOutputStatus<IndirizzoDTO>> =
		new EventEmitter<ComponentOutputStatus<IndirizzoDTO>>();

	indirizzoChangedSub: Subscription;

	isIndirizzoEstero$: Observable<boolean>;

	constructor() { }

	ngOnInit() {

		console.log('[IndirizzoDTO]', this.indirizzo);

		this.form = new FormGroup({});

		const isIndirizzoEstero =
			this.indirizzo != null &&
			this.indirizzo.localita != null &&
			this.indirizzo.localita.comune != null &&
			this.indirizzo.localita.comune.startsWith('Z');

		const indirizzoEstero = new FormControl(
			{ value: isIndirizzoEstero, disabled: false }, [Validators.required]
		);
		this.form.addControl('indirizzoEstero', indirizzoEstero);

		this.isIndirizzoEstero$ = indirizzoEstero.valueChanges.pipe(
			tap(_ => {
				this.done.emit(ComponentOutputStatus.of(false, null))
			}),
			shareReplay(),
			startWith(isIndirizzoEstero)
		);

	}

	public indirizzoReady(indirizzoStatus: ComponentOutputStatus<IndirizzoDTO>) {
		this.done.emit(indirizzoStatus);
	}
}
